//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

// Maps to RMS CreationSource
export enum RightsCreationSource {
  ApprovedRightsRequest = 'ApprovedRightsRequest',
  SkippedRightsRequest = 'SkippedRightsRequest',
  FanreelUpload = 'FanreelUpload',
  ClientDirectUpload = 'ClientDirectUpload',
  ImportOpsJob = 'ImportOpsJob',
  ManuallySet = 'ManuallySet',
  MediaImportService = 'MediaImportService',
  RelationshipClientOwned = 'RelationshipClientOwned',
  RelationshipClientToClient = 'RelationshipClientToClient',
  RelationshipInfluencerToClient = 'RelationshipInfluencerToClient',
}
